<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    @closed="handleClose"
    width="600px"
  >
    <el-form ref="form" :model="formData" :inline="false" label-position="top">
        <template v-for="(item, index) in valueRules.items">
            <el-row
                :key="index"
            >
                <el-form-item
                    :label="getFormItemLabel(item)"
                    :prop="`${item.properties.id.enum[0]}`"
                    :rules="getFormItemRules(item)"
                >
                    <!-- 多层模板/单层模板 -->
                    <template v-if="item.properties.id.type === 'model'">
                        <SelectTemplate
                            v-model="formData[`${item.properties.id.enum[0]}`].value"
                            :firstTempId="formData[`${item.properties.id.enum[0]}`].firstTempId"
                            :valueId="formData[`${item.properties.id.enum[0]}`].valueId"
                            :templateList="item.properties.value.enum[0].preprocessingSaleAttrValTemplateValueList"
                            :readonly="(item.features && item.features.isLocked === '1')"
                            @change="val => handleTemplateChanged(val, item.properties)"
                        />
                    </template>
                    <template v-else-if="item.properties.value.enum || item.properties.description">
                        <!-- 下拉选项 -->
                        <el-select
                            v-model="formData[`${item.properties.id.enum[0]}`].value"
                            width="300px"
                            :allow-create="(item.features && item.features.isLocked === '0')"
                            :blur-create="(item.features && item.features.isLocked === '0')"
                        >
                            <template v-for="(opName, opIndex) in item.properties.value.enum">
                                <el-option :key="opIndex" :label="opName" :value="opName" />
                            </template>
                        </el-select>
                    </template>
                    <template v-else-if="item.properties.unit"><!-- 数值单位 -->
                        <el-input-digit
                            v-model.number="formData[`${item.properties.id.enum[0]}`].value"
                            style="width: 300px"
                            class="number-unit-wrap"
                            :allow-create="(item.features && item.features.isLocked === '0')"
                            :blur-create="(item.features && item.features.isLocked === '0')"
                        >
                            <el-select
                                v-model="formData[`${item.properties.id.enum[0]}`].unit"
                                style="width: 75px"
                            >
                                <template v-for="(opName, opIndex) in (item.properties.unit.enum || [])">
                                    <el-option :key="opIndex" :label="opName" :value="opName" />
                                </template>
                            </el-select>
                        </el-input-digit>
                    </template>
                    <!-- 关联类目属性 -->
                    <!-- <template v-else-if="item.properties.description">
                        关联类目属性 TODO
                    </template> -->
                    <template v-else>
                        <!-- {{ item.properties.id.enum[0] }}
                        {{formData[`${item.properties.id.enum[0]}`].value}} -->
                        <el-input
                            v-model="formData[`${item.properties.id.enum[0]}`].value"
                            style="width: 300px"
                        />
                    </template>
                </el-form-item>
            </el-row>
        </template>
    </el-form>
    <template slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import SelectTemplate from './SelectTemplate.vue';
export default {
    components: {
        SelectTemplate
    },
    props: {
        checkValueItemCrossFunc: {
            type: Function,
            default: () => {
                return () => {
                    return false;
                }
            }
        }
    },
    data() {
        return {
            dialogVisible: false,
            formData: {
                14: {value: '',  unit: ''},
                15: {value: '',  unit: ''},
                16: {value: '',  unit: ''},
                17: {value: '',  unit: ''},
                719: {value: '',  unit: ''}
            },
            valueRules: {
                items: [],
            },
            ruleUnValidTips: null,
        }
    },
    computed: {
        dialogTitle() {
            const { title } = this.valueRules;
            if (title) {
                return title;
            }
            return '规格值编辑';
        }
    },
    methods: {
        handleShow(extendValues, valueItemRule, defaultValue) {
            const { items } = valueItemRule;
            items.forEach((element, eIdx) => {
                if (!extendValues[`${element.properties.id.enum[0]}`]) {
                    extendValues[`${element.properties.id.enum[0]}`] = {
                       id: `${element.properties.id.enum[0]}`,
                       value: eIdx === 0 ? defaultValue : '',
                       valueId: '',
                       unit: '',
                    }
                }
            });
            this.formData = cloneDeep(extendValues);
            this.valueRules = cloneDeep(valueItemRule);
            this.dialogVisible = true;
        },
        getFormItemLabel(ruleItem) {
            // ruleItem.properties.id.type === 'model' || 
            if (ruleItem.features && ruleItem.features.text) {
                return ruleItem.features.text;
            }
            return '自定义'
        },
        getFormItemRules(ruleItem) {
            const { required } = ruleItem;
            if (!required) {
                return null;
            }
            const { properties } = ruleItem;
            const validRuleItem = (rule, value, callback) => {
                if (!value) {
                    return callback('数据映射错误')
                }
                const formValue = this.formData[properties.id.enum[0]];
                if (!formValue) {
                    return callback();
                }
                let validResult = true;
                const keyMap = {
                    id: 'id',
                    value: '必填项',
                    unit: '单位为必填项，'
                }
                for (let i = 0; i < required.length; i++) {
                    const key = required[i];
                    if (!formValue[key]) {
                        validResult = { errorMsg: `${keyMap[key]}不能为空`};
                        break;
                    }
                }
                if (validResult !== true) {
                    return callback(new Error(validResult.errorMsg));
                }
                return callback();
            }
            return [{ required: true, validator: validRuleItem }]
        },
        getFormData() {
            const formData = {};
            const { items } = this.valueRules;
            items.forEach(element => {
                if (element.properties.id.enum[0]) {
                    formData[`${element.properties.id.enum[0]}`] = this.formData[`${element.properties.id.enum[0]}`]
                }
            });
            return formData;
        },
        handleTemplateChanged({ name, id, firstTempId }, properties) {
            const modelId = properties.id.enum[0];
            const { preprocessingSaleAttrValTemplateDTO = {} } = properties.value.enum[0]
            const { features = {} } = preprocessingSaleAttrValTemplateDTO;
            // 互斥模板要求不能跨分组
            if (firstTempId && features.isCrossLevel === '0') {
                const { preprocessingSaleAttrValTemplateValueList: templateList } = properties.value.enum[0];
                const valid = this.checkValueItemCrossFunc(modelId, firstTempId, templateList);
                if (valid !== true) {
                    const oldTemp = templateList.find(item => {
                        return item.id === valid.firstTempId;
                    });
                    const newTemp = templateList.find(item => {
                        return item.id === firstTempId;
                    });
                    this.ruleUnValidTips = `“${oldTemp.name}”将换成“${newTemp.name}”，已选${oldTemp.name}名称将被清空，确认更换？`
                } else {
                    this.ruleUnValidTips = null;
                }
            }
            Object.assign(this.formData[modelId], {
                value: name,
                valueId: id,
                firstTempId: firstTempId || null,
            });
        },
        handleSubmit() {
            this.$refs.form.validate(valid => {
                if (!valid) return false;
                const formData = this.getFormData();
                this.$emit('on-success', {
                    extendValues: cloneDeep(formData),
                    ruleUnValidTips: this.ruleUnValidTips
                });
                this.handleClose();
            })
        },
        handleClose() {
            this.dialogVisible = false;
            this.ruleUnValidTips = null;
        }
    }
}
</script>

<style lang="scss" scoped>
.number-unit-wrap{
    display: block;
    ::v-deep .suffix{
        right: 0;
    }
}

</style>